import { supabase } from './supabase';

// #2395: fetch() for Charlie's own /api routes that now require a signed-in session.
// Adds the current session's access token as a Bearer header; everything else is plain fetch.
export async function authFetch(url, options = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  const headers = { ...(options.headers || {}) };
  if (session?.access_token) headers.Authorization = `Bearer ${session.access_token}`;
  return fetch(url, { ...options, headers });
}
